
DebouncerFactory = ($q, $timeout) ->
    'ngInject'

    class Debouncer

        constructor: (func, delay) ->
            @func = func
            @delay = delay
            @timeoutPromise = null
            @deferred = null

        Object.defineProperties @::,
            promise: get: ->
                if @deferred? then @deferred.promise else $q.reject()

        call: =>
            @deferred = @deferred or $q.defer()
            $timeout.cancel(@timeoutPromise)
            @timeoutPromise = $timeout(@resolve, @delay)
            return @promise

        resolve: =>
            deferred = @deferred
            @deferred = null
            return $q.when(@func()).then (result) ->
                deferred.resolve(result)
                return result

    return Debouncer


module.factory 'Debouncer', DebouncerFactory
